<h2 mat-dialog-title>Fill Hours</h2>
<mat-dialog-content>
  <div class="flex flex-col flex-wrap justify-start items-start gap-1 w-[350px]">
    <mat-form-field class="w-full" floatLabel="always">
      <mat-label>Choose a date</mat-label>
      <input matInput [matDatepicker]="picker" [formControl]="dateInput" required />
      @if (dateInput.invalid) {
        <mat-error>{{ errorDateInputMessage() }}</mat-error>
      } @else {
        <mat-hint>MM/DD/YYYY</mat-hint>
      }
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <app-single-dropdown
      class="w-full"
      [label]="'Projects'"
      [inputControl]="projectInput"
      [dropdownOptions]="_projectsFeature.projects()"
      [displayValue]="displayProjectInputValue"
      [errorInputMessage]="errorProjectInputMessage()"
      (onBlur)="updateProjectInputErrorMessage()"
    ></app-single-dropdown>

    <app-single-dropdown
      class="w-full"
      [label]="'Phase'"
      [inputControl]="phaseInput"
      [dropdownOptions]="projectInput.value ? filterPhasesByProjectNo(_projectsFeature.phases(), projectInput.value?.projectNo) : _projectsFeature.phases()"
      [displayValue]="displayPhaseInputValue"
      [errorInputMessage]="errorPhaseInputMessage()"
      (onBlur)="updatePhaseInputErrorMessage()"
    ></app-single-dropdown>

    <app-single-dropdown
      class="w-full"
      [label]="'Task'"
      [inputControl]="taskInput"
      [dropdownOptions]="taskOptions"
      [displayValue]="displayTaskInputValue"
      [errorInputMessage]="errorTaskInputMessage()"
      (onBlur)="updateTaskInputErrorMessage()"
    ></app-single-dropdown>

    <mat-form-field class="w-full" floatLabel="always">
      <mat-label>Duration</mat-label>
      <input matInput placeholder="hh:mm" [formControl]="timeInput" (blur)="updateTimeInputErrorMessage(); onFormatTimeDuration()" required />
      @if (timeInput.invalid) {
        <mat-error>{{ errorTimeInputMessage() }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full" floatLabel="always">
      <mat-label>Comment</mat-label>
      <textarea matInput [formControl]="commentInput" (blur)="updateCommentInputErrorMessage()" required></textarea>
      @if (commentInput.invalid) {
        <mat-error>{{ errorCommentInputMessage() }}</mat-error>
      }
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (_timesheetFeature.selectedTimesheetLine()) {
    <button mat-button (click)="openDeleteEntryDialog()"><span class="text-red-600">Delete</span></button>
  }
  <button mat-button mat-dialog-close>Cancel</button>
  @if (_timesheetFeature.isLoadingSubmittingTimesheetLine() || _timesheetFeature.isLoadingUpdatingTimesheetLine()) {
    <div class="w-[100px] flex justify-center items-center">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  } @else {
    <button mat-button [disabled]="!projectInput.valid || !phaseInput.valid || !taskInput.valid || !timeInput.valid || !commentInput.valid" (click)="onSubmitTimesheetEntry()">Submit</button>
  }
</mat-dialog-actions>
